<template>
  <div class="setting-form-wrap">
    <a-collapse v-model="activeKey">
      <a-collapse-panel key="common" header="Common">
        <a-form
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-item
            v-for="(item, index) in configArrCommon"
            :key="index"
            :label="item.label"
          >
            <ColorPicker
              section="common"
              :field="item.field"
              :color.sync="customTheme.common[item.field]"
            ></ColorPicker>
          </a-form-item>
          <a-form-item label="Upload Company Icon">
            <a-upload
              name="image"
              list-type="picture-card"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="`${API_URL}upload/image`"
              :before-upload="beforeUpload"
              @change="handleChange"
            >
              <img
                class="company-logo"
                v-if="customTheme.common && customTheme.common.logo"
                :src="customTheme.common.logo"
                alt="Company Icon"
              />
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
          </a-form-item>
        </a-form>
      </a-collapse-panel>
      <a-collapse-panel key="size" header="Select Party Size">
        <a-form
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-item
            v-for="(item, index) in conifgArrSize"
            :key="index"
            :label="item.label"
          >
            <ColorPicker
              section="size"
              :field="item.field"
              :color.sync="customTheme.size[item.field]"
            ></ColorPicker>
          </a-form-item>
        </a-form>
      </a-collapse-panel>
      <a-collapse-panel key="calendar" header="Select Date">
        <a-form
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-item
            v-for="(item, index) in configArrCalendar"
            :key="index"
            :label="item.label"
          >
            <ColorPicker
              section="calendar"
              :field="item.field"
              :color.sync="customTheme.calendar[item.field]"
            ></ColorPicker>
          </a-form-item>
        </a-form>
      </a-collapse-panel>
      <a-collapse-panel key="time" header="Select Time">
        <a-form
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-item
            v-for="(item, index) in configArrTime"
            :key="index"
            :label="item.label"
          >
            <ColorPicker
              section="time"
              :field="item.field"
              :color.sync="customTheme.time[item.field]"
            ></ColorPicker>
          </a-form-item>
        </a-form>
      </a-collapse-panel>
      <a-collapse-panel key="customer" header="Customer Information">
        <a-form
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-item
            v-for="(item, index) in configArrCustomer"
            :key="index"
            :label="item.label"
          >
            <ColorPicker
              section="customer"
              :field="item.field"
              :color.sync="customTheme.customer[item.field]"
            ></ColorPicker>
          </a-form-item>
        </a-form>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import axios from "axios";
import ColorPicker from "@/components/ColorPicker";
export default {
  name: "ConfigPanel",
  components: {
    ColorPicker,
  },
  inject: ["customThemeFn"],
  computed: {
    customTheme: {
      get() {
        return this.customThemeFn();
      },
      set(val) {},
    },
  },
  data() {
    return {
      API_URL: process.env.API_URL,
      activeKey: ["common", "size", "calendar", "time", "customer"],
      configArrCommon: [
        {
          label: "Title Color",
          field: "titleColor",
        },
        {
          label: "SubTitle Color",
          field: "subTitleColor",
        },
        {
          label: "Top Icon Color",
          field: "iconColor",
        },
        {
          label: "Next Button Color",
          field: "nextColor",
        },
      ],
      conifgArrSize: [
        {
          label: "Dot Color",
          field: "dotColor",
        },
        {
          label: "Size Button Color",
          field: "btnBgColor",
        },
      ],
      configArrCalendar: [
        {
          label: "Dot Color",
          field: "dotColor",
        },
        {
          label: "Panel Color",
          field: "panelBgColor",
        },
        {
          label: "Today Color",
          field: "todayBgColor",
        },
        {
          label: "Selected Date Color",
          field: "selectedBgColor",
        },
      ],
      configArrTime: [
        {
          label: "Dot Color",
          field: "dotColor",
        },
        {
          label: "Small Dot Color",
          field: "dotSmallColor",
        },
        {
          label: "Time Button Color",
          field: "timeBtnColor",
        },
      ],
      configArrCustomer: [
        {
          label: "Dot Color",
          field: "dotColor",
        },
      ],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 11 },
      },
      loading: false,
      imageUrl: "",
    };
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleChange(info) {
      if (info.file.status == "uploading") {
        this.customTheme.common.logo = "";
        console.log("uploading");
        this.loading = true;
      }
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        this.loading = false;
      }
      if (info.file.status === "done") {
        this.loading = false;
        if (info.file.response.code == 200) {
          this.$message.success(`Icon uploaded successfully`);
          this.customTheme.common.logo = info.file.response.data.file_path;
        } else {
          this.$message.error(`${info.file.name} file upload failed.`);
        }
        // console.log(info);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
        this.loading = false;
      }
    },
    // async upload(params) {
    //   // console.log(a, b, c);
    //   const { file } = params;
    //   const formData = new FormData();
    //   formData.append("image", file);
    //   console.log(file);
    //   const res = await axios.post(
    //     process.env.API_URL + "upload/image",
    //     formData
    //   );
    //   console.log(res);
    // },
    beforeUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("You can only upload JPG file!");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("Image must smaller than 5MB!");
      }
      return isJpgOrPng && isLt5M;
    },
  },
};
</script>


<style lang="scss" scoped="scoped">
.setting-form-wrap {
  width: 400px;
  flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// src/page/Preview/components/ConfigPanel.vue